import { httpClient } from './httpClient';

export interface CaseSummaryMetadata {
  id: string;
  caseId: string;
  status: 'GENERATING' | 'READY' | 'FAILED';
  caseName: string | null;
  sizeBytesPdf: number | null;
  sizeBytesDocx: number | null;
  generatedAt: string;
}

/**
 * Client for the auto-generated per-case summary dossier (report-service).
 *
 * The summary is generated automatically when analysis completes and locked
 * thereafter (no invalidation, no manual regenerate). This client only reads
 * existing summaries and triggers downloads.
 */
export const caseSummaryApi = {
  /** Returns metadata for the case summary if one exists; null otherwise. */
  getForCase: async (caseId: string): Promise<CaseSummaryMetadata | null> => {
    try {
      const data = await httpClient.get<CaseSummaryMetadata>(`/reports/case-summary/${caseId}`);
      return data ?? null;
    } catch {
      return null;
    }
  },

  /** Trigger browser download of the case summary in the requested format. */
  download: async (caseId: string, format: 'pdf' | 'docx'): Promise<void> => {
    await httpClient.downloadFile(`/reports/case-summary/${caseId}/download`, { format });
  },
};
